var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "el-checkbox",
        {
          on: {
            change: function($event) {
              return _vm.onChange("warehousing")
            }
          },
          model: {
            value: _vm.job.warehousing,
            callback: function($$v) {
              _vm.$set(_vm.job, "warehousing", $$v)
            },
            expression: "job.warehousing"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage")))]
      ),
      _c(
        "el-checkbox",
        {
          on: {
            change: function($event) {
              return _vm.onChange("landTransportation")
            }
          },
          model: {
            value: _vm.job.landTransportation,
            callback: function($$v) {
              _vm.$set(_vm.job, "landTransportation", $$v)
            },
            expression: "job.landTransportation"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")))]
      ),
      _c(
        "el-checkbox",
        {
          on: {
            change: function($event) {
              return _vm.onChange("selfDeliver")
            }
          },
          model: {
            value: _vm.job.selfDeliver,
            callback: function($$v) {
              _vm.$set(_vm.job, "selfDeliver", $$v)
            },
            expression: "job.selfDeliver"
          }
        },
        [
          _vm._v(
            _vm._s(_vm.$t("SeaExport.NotResponsibleForTruckingAndLoading"))
          )
        ]
      ),
      _c(
        "el-checkbox",
        {
          on: {
            change: function($event) {
              return _vm.onChange("backUpWarehouse")
            }
          },
          model: {
            value: _vm.job.backUpWarehouse,
            callback: function($$v) {
              _vm.$set(_vm.job, "backUpWarehouse", $$v)
            },
            expression: "job.backUpWarehouse"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.BackUpWarehouse")))]
      ),
      _c(
        "el-checkbox",
        {
          on: {
            change: function($event) {
              return _vm.onChange("otherService")
            }
          },
          model: {
            value: _vm.job.otherService,
            callback: function($$v) {
              _vm.$set(_vm.job, "otherService", $$v)
            },
            expression: "job.otherService"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.Other")))]
      ),
      _c("el-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.job.otherService,
            expression: "job.otherService"
          }
        ],
        attrs: { maxlength: "10" },
        on: {
          change: function($event) {
            return _vm.onChange("otherRemark")
          }
        },
        model: {
          value: _vm.job.otherRemark,
          callback: function($$v) {
            _vm.$set(_vm.job, "otherRemark", $$v)
          },
          expression: "job.otherRemark"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }